import React from "react";
import {
  Row,
  Col,
  Input,
  Avatar,
  Button,
  Space,
  message,
  Upload,
  Form,
  Select,
  Modal,
  Image,
  Dropdown,
  Drawer,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { PushpinFilled, CloseOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import config from "../config";
import withRouter from "../withRouter";
import PassengerStore from "../store/PassengerStore";
import CompanyStore from "../store/CompanyStore";
import VehicleStore from "../store/VehicleStore";
import PassengerAdd from "./PassengerAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import conf from "../config";
import uploadIcon from "../assets/images/NewDesign/upload.svg";
import sampleDownloadIcon from "../assets/images/NewDesign/SampleDownload.svg";
import sampleUploadIcon from "../assets/images/NewDesign/SampleUpload.svg";
import UploadTitleIcon from "../assets/images/NewDesign/UploadTitle.svg";
import uploadOutlined from "../assets/images/NewDesign/uploadOutlined.svg";
import axios from "axios";
import Cookies from "universal-cookie";
import { decode as base64_decode, encode as base64_encode } from "base-64";
const { Option } = Select;
const { Dragger } = Upload;
class PassengerList extends React.Component {
  formRef = React.createRef();
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.vehicleStore = new VehicleStore(this);

    this.passengerStore = new PassengerStore();
    this.cookies = new Cookies();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      showUpload: false,
      companyVal_Lab: "",
      openModal: false,
      passengerId: "",
      passengerId: [],
      oldvehicleId: "",
      showDeleteModal: false,
      openPassengerForm: false,
      passengerIdEdit: "",
      // newPassengerId:""
      schollPassenger: false,
      listDataUpdate: false,
      deletetooltip: true,
      showAlertModal: false,
      companyFieldHighlight: false,
      reAssignVehicle: "",
      companyId: "",

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        title: context.translate("_PASSENGER_TYPE_"),
        width: 80,
        dataIndex: "type",
        key: "type",
        ellipsis: {
          showTitle: true,
        },
        // fixed: "left",
        render: (value) => {
          if (value === "Student") {
            return <div className="list-status-type">{value}</div>;
          }
          if (value === "Employee") {
            return <div className="list-status-typeDist">{value}</div>;
          }
          // if (value === "Student") {
          //   return <Tag color={config.typeColor1}>{value}</Tag>;
          // }
          // if (value === "Employee") {
          //   return <Tag color={config.typeColor2}>{value}</Tag>;
          // }
        },
      },
      {
        title: context.translate("_NAME_"),
        width: 80,
        dataIndex: "studentName",
        key: "studentName",
        ellipsis: {
          showTitle: true,
        },
        // fixed: "left",
        render: (value, row) => {
          if (row.employeeName !== null) {
            return (
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("passengerList") && this.onEdit(row);
                }}
              >
                {row.employeeName}
              </Link>
            );
          } else {
            return (
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("passengerList") && this.onEdit(row);
                }}
              >
                {value}
              </Link>
            );
          }
        },
      },

      {
        // title: "Class / Department",
        title: context.translate("_CLASS_DEPARTMENT_"),
        dataIndex: "className",
        key: "className",
        width: 100,
        ellipsis: {
          showTitle: true,
        },
        render: (val, row) => {
          if (row.employeeDepartment !== null) {
            return row.employeeDepartment;
          } else {
            return val;
          }
        },
      },
      {
        title: context.translate("_TAG_ID_"),
        dataIndex: "tagId",
        key: "tagId",
        width: 60,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_MOBILE_NUMBER_"),
        dataIndex: "mobileNo",
        key: "mobileNo",
        width: 70,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_BUSNO_"),
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        width: 70,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_LOCATION_"),
        dataIndex: "pickUpPoint",
        key: "location",
        width: 130,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value) {
            return (
              <span>
                <Avatar
                  style={{ backgroundColor: config.locationColor, margin: 2 }}
                  size={15}
                  icon={<PushpinFilled />}
                />
                {value}
              </span>
            );
          }
        },
      },
      {
        title: context.translate("_PICKUP_TIME_"),
        dataIndex: "pickUpTime",
        key: "6",
        width: 70,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DROP_OFF_TIME_"),
        dataIndex: "dropOffTime",
        key: "dropOffTime",
        width: 70,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        ellipsis: {
          showTitle: true,
        },
        // fixed: "right",
        width: 40,
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("passengerList") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "14px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("passengerList") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "14px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];

    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={async (e) => {
                this.state.passengerId?.length > 0
                  ? await this.setState({ showDeleteModal: true })
                  : await this.setState({ showAlertModal: true });
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={require("../assets/images/NewDesign/Delete.png")}
              ></Avatar>
              {context.translate("_DELETE_PASSENGER_")}
            </div>
          ),
          key: "delete",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={async (e) => {
                this.state.passengerId.length > 0
                  ? await this.setState({ openModal: true })
                  : await this.setState({ showAlertModal: true });
                await this.vehicleStore.getVehiclesCompanyId(
                  this.state.companyId
                );
                this.setState({ loadList: 1 });
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
              ></Avatar>
              {context.translate("_REASSIGN_VEHICLE_")}
            </div>
          ),
          key: "reassign",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
              ></Avatar>
              {context.translate("_DASH_BOARD_")}
            </div>
          ),
          key: "dashboard",
        },
      ],
    };

    this.ExportMenuProps1 = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={async (e) => {
                this.state.passengerId?.length > 0
                  ? await this.setState({ showDeleteModal: true })
                  : await this.setState({ showAlertModal: true });
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={require("../assets/images/NewDesign/Delete.png")}
              ></Avatar>
              {context.translate("_DELETE_PASSENGER_")}
            </div>
          ),
          key: "delete",
        },
      ],
    };

    this.companyStore = new CompanyStore(this);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const passengerStates = this.context.viewStateStore.passengerStatesObj;

      await this.passengerStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        searchField: passengerStates.searchText,
        companyId: passengerStates.companyId,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        passengerStates.companyId
      );

      await this.setState({ loadList: 0 });

      await this.setState({
        companyVal_Lab: singleData,
        searchField: passengerStates.searchText,
      });
      await this.setState({ listDataUpdate: false });
      // await this.passengerStore.loadData({ offset: 0, limit: 50 });
      // this.setState({pageSize:50,clientHeight:window.innerHeight});
      //this.handleSearch();
    }
  }

  async componentDidMount() {
    let tokendata = this.cookies.get("data")
      ? JSON.parse(base64_decode(this.cookies.get("data")))
      : "";
    const userToken = tokendata.userToken;

    this.setState({ token: userToken });
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ userId: this.props.getUserData().userId });
      await this.vehicleStore.getVehiclesCompanyId(
        this.props.getUserData().userCompanyId
      );
      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
  }
  onEdit = async (record) => {
    const passengerId = record.passengerId;
    if (passengerId) {
      await this.context.viewStateStore.setPassengerStates({
        companyId: record.companyId,
        searchText: this.state.searchField,
      });
      await this.setState({ passengerIdEdit: passengerId });
      await this.setState({ openPassengerForm: true });

      // this.props.navigate(
      //   this.props.params.id
      //     ? "/passengeradd/" + passengerId + "?schollPassenger=1"
      //     : "/passengeradd/" + passengerId
      // );
    }
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      loadList: 1,
      currentPage: 1,
      pageSize: 50,
      passengerId: [],
    });

    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData, companyId: comp.value });

    await this.handleSearch();
    this.setState({ loadList: 1 });
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.passengerStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }
  async onDelete(record) {
    this.setState({ deletetooltip: true });
    const response = await this.passengerStore.deleteRecord({
      passengerId: record.passengerId,
    });
    // console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }
  searchInput = async (e) => {
    const value = e.target.value;
    if (value.length > 3) {
      await this.passengerStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        // companyId: this.state.companyVal_Lab[0].value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 0 });
    } else if (value.length === 0) {
      await this.passengerStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        // searchField: value,
        // companyId: this.state.companyVal_Lab[0].value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 0, currentPage: 1 });
    }
  };

  async searchInputButton() {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      await this.passengerStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
        searchFieldDate: this.state.searchFieldDate,
        companyId: this.state.companyId,
      });
      await this.setState({ loadData: 1 });
    }
  }

  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      const formData = new FormData();
      formData.append("excelFile", file);
      formData.append("fileType", "passengerimport");
      formData.append("fieldName", "excelFile");

      console.log(this.state.token, "token");
      const response = await axios.post(
        // config.baseURL + this.companyStore.fileUploadUrl,
        config.NodeUrl + "/passenger/uploadExcel",
        formData,
        {
          headers: {
            token: this.state.token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress({ percent });
          },
        }
      );

      onSuccess(response.data);
    } catch (error) {
      onError(error);
    }
  };

  onExcelSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.companyId,
      excelFile: this.state.excelFile,
    };

    if (data.excelFile) {
      const resp = await this.passengerStore.addStudentByExcel(data);

      if (resp?.success == "S") {
        message.success(resp.message);
        this.setState({ excelFile: "" });
      } else {
        message.error(resp.errors[0].error);
      }
      if (resp.message) {
        this.setState({ showUpload: false });
        this.formRef.current?.resetFields();
      }
    } else {
      message.error("Please Upload Excel File");
    }
  };

  async companySearch(companyId) {
    const data = await this.vehicleStore.getVehiclesCompanyId(companyId.value);

    await this.setState({ loadList: 1 });
  }

  // onReassignVehicle = async (value) => {
  //   console.log(this.state.passengerId.join(","));

  //   const assignVehicle = this.state.passengerId.forEach(async (value1) => {
  //     const data = {
  //       passengerId: value1,
  //       newvehicleId: value.vehicleId,
  //       oldvehicleId: this.state.oldvehicleId,
  //     };
  //     console.log(data);
  //     const resp = await this.passengerStore.reAssignVehicle(data);
  //     console.log(resp);
  //     if (resp?.success === "S") {
  //       console.log(resp.message);
  //       message.success(resp.message);
  //       console.log(resp.message);
  //       this.setState({ openModal: false });
  //       this.formRef.current?.resetFields();
  //     } else {
  //       message.error(resp.message);
  //       this.setState({ openModal: false });
  //       this.formRef.current?.resetFields();
  //     }
  //   });
  //   this.handleSearch();
  // };

  onReassignVehicle = async (value) => {
    const assignVehicle = this.state.reAssignVehicle.forEach(async (value1) => {
      const data = {
        passengerId: value1.passengerId,
        newvehicleId: value.vehicleId,
        oldvehicleId: value1.oldvehicleId,
      };

      const resp = await this.passengerStore.reAssignVehicle(data);

      if (resp?.success === "S") {
        message.success(resp.message);

        this.setState({ openModal: false });
        this.formRef.current?.resetFields();
      } else {
        message.error(resp.message);
      }
    });
    await this.handleSearch();
  };

  deleteMultiplePassenger = async (value) => {
    const companyIdArray = this.state.reAssignVehicle.map(
      (val) => val.companyId
    );
    const companyIdData = companyIdArray.join(",");

    let flag = 0;

    for (const id of value) {
      const data = {
        passengerId: id,
      };

      const response = await this.passengerStore.deleteRecord(data);
      // this.setState({deleteResponse:response})
      if (response?.data?.success === "S") {
        if (flag === 0) {
          message.success(response.data.message);
        }
        await this.passengerStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          searchField: this.state.searchField,
          // companyId: companyIdData,
          companyId: this.state.companyId,
        });

        await this.setState({ loadList: 1 });
        flag++;
      } else {
        message.error(response.data.message);
      }
    }
  };

  responseMsg = async (response) => {
    if (response?.success === "S") {
      message.success(response.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openPassengerForm: false });
      // await this.props.navigate(this.queryId?"/passengerList2/1":"/passengerList");
    } else {
      message.error(response.errors[0].tagId);
    }
  };

  validateFile = (file) => {
    this.setState({ fileList: file });

    const maxSize = conf.UploadExcelSize;
    if (file.size > maxSize) {
      message.error("File size must be less than or equal to 1MB");
      return false;
    }
    return true;
  };

  closeModal = () => {
    this.setState({ openPassengerForm: false, passengerIdEdit: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    await this.passengerStore.loadData({
      companyId: this.state.companyId,
      offset: 0,
      limit: 50,
      searchField: "",
    });
    this.setState({ loading: false, searchField: "", currentPage: 1 });
  };

  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  style={companyInputBox}
                  // allowClear={true}
                  // style={{ width: 200 }}
                />
                <Input
                  // placeholder="Search by Name,Mobile No,Tag Id,Bus No"
                  placeholder={this.context.translate(
                    "_SEARCH_BY_NAME_MOBILE_TAGID_BUSNO_"
                  )}
                  value={this.state.searchField ? this.state.searchField : ""}
                  style={{ width: 400, borderRadius: "25px" }}
                  onKeyUp={(e) => this.searchInput(e)}
                  onChange={(e) => {
                    this.setState({ searchField: e.target.value });
                  }}
                />
                {/* <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={() => {
                    this.searchInputButton();
                  }}
                /> */}
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              {/* {this.props.params.id && (
                <>
                  <div style={{ display: this.props.params.id ? "" : "none" }}>
                    <Button
                      type={config.uploadBoxType}
                      onClick={() => {
                        this.setState({ showUpload: true });
                      }}
                    >
                      <i
                        class="bi bi-upload"
                        style={{ marginRight: "5px" }}
                      ></i>

                      {this.context.translate("_UPLOAD_")}
                    </Button>
                  </div>
                  <div style={{ display: this.props.params.id ? "" : "none" }}>
                    <Button type="primary">
                      <i
                        class="bi bi-speedometer2"
                        style={{ marginRight: "5px" }}
                      ></i>

                      {this.context.translate("_DASH_BOARD_")}
                    </Button>
                  </div>
                  <div style={{ display: this.props.params.id ? "" : "none" }}>
                    <Tooltip
                      // title="Reassign Vehicle"
                      title={this.context.translate("_REASSIGN_VEHICLE_")}
                      color={config.tooltipColorEdit}
                    >
                      <Button
                        type="primary"
                        onClick={async (e) => {
                          this.state.passengerId.length > 0
                            ? await this.setState({ openModal: true })
                            : await this.setState({ showAlertModal: true });
                          await this.vehicleStore.getVehiclesCompanyId(
                            this.state.companyId
                          );
                          this.setState({ loadList: 1 });
                        }}
                      >
                        <i
                          class="bi bi-car-front"
                          style={{ marginRight: "5px" }}
                        ></i>
                      </Button>
                    </Tooltip>
                  </div>
                </>
              )} */}

              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      marginInlineEnd: "20px",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <Dropdown
                  overlayClassName="export-dropdown"
                  menu={
                    this.props.params.id == 1
                      ? this.ExportMenuProps
                      : this.ExportMenuProps1
                  }
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      marginInlineEnd: "20px",
                    }}
                    src={kebabIcon}
                  ></Image>
                </Dropdown>

                {this.props.params.id && (
                  <Button
                    className="uploadExcelButton"
                    onClick={() => this.setState({ showUpload: true })}
                  >
                    <Image
                      style={{
                        height: 18,
                      }}
                      src={uploadIcon}
                    />
                  </Button>
                )}

                {this.props.canCreate("passengerList") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({
                        openPassengerForm: true,
                        passengerIdEdit: "",
                      })
                    }
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            rowSelection={{
              fixed: true,
              //  columnWidth: 2,
              selectedRowKeys: this.state.passengerId,
              onChange: async (selectedRowKeys, selectedRows) => {
                // await this.setState({})
                console.log(selectedRowKeys, selectedRows);
                await this.setState({ passengerId: selectedRowKeys });
                // await this.setState({
                //   oldvehicleId: selectedRows[0]?.vehicleId,
                // });
                await this.setState({ reAssignVehicle: selectedRows });
              },
            }}
            rowKey="passengerId"
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.passengerStore?.total}
            columns={this.columns}
            dataSource={this.passengerStore?.passengers}
            loading={this.passengerStore?.loading}
            onChange={this.handleTableChange}
          />

          {/* {this.state.showUpload && (
            <>
              <Modal
                open={this.state.showUpload}
                maskClosable={false}
                // title="File Upload"
                placeholder={this.context.translate("_FILE_UPLOAD_")}
                onOk={() => this.setState({ showUpload: false })}
                onCancel={() => this.setState({ showUpload: false })}
                footer={false}
                width={400}
                // style={{width:100}}
              >
                <Form
                  name="excelimport"
                  ref={this.formRef}
                  layout="vertical"
                  onFinish={this.onExcelSubmit}
                  style={{ maxWidth: "100%" }}
                >
                  {this.props.getUserData().isadmin === -1 && (
                    <Form.Item
                      name="companyId"
                      label={this.context.translate("_ACCOUNT_")}
                      rules={[{ required: true }]}
                    >
                      <CompanyAutocomplete
                        // allowClear={true}
                        onChange={(companyId) => {
                          this.setState({ companyId: companyId.value });
                          this.companySearch(companyId);
                          this.vehicleStore.getVehiclesCompanyId(
                            companyId.value
                          );
                        }}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  )}
                  <Form.Item
                    // label="Select Vehicle"
                    label={this.context.translate("_SELECT_VEHICLE_")}
                    name="vehicleId"
                    rules={[
                      {
                        required: true,
                        message: this.context.translate("_SELECT_VEHICLE_"),
                      },
                    ]}
                  >
                    <Select
                      // placeholder="Select Asset"
                      showSearch
                      // fieldNames={{ value: "vehicleId", label: "vehicleNo" }}
                      optionFilterProp="children"
                      // options={this.vehicleStore?.getVehiclesUsingCompanyId}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                        (val) => {
                          return (
                            <Option value={val.vehicleId}>
                              {val.vehicleNo}
                            </Option>
                          );
                        }
                      )}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="excelFile"
                    // label="Excel File"
                    label={this.context.translate("_EXCEL_FILE_")}
                    className="uploadFile"
                    rules={[{ required: true }]}
                  >
                    <Upload
                      // status= 'error'
                      showProgress="true"
                      name="excelFile"
                      action={
                        config.baseURL + "/index.php?c=company&a=fileupload"
                      }
                      listType="text"
                      data={{
                        fileType: "passengerimport",
                        fieldName: "excelFile",
                      }}
                      onChange={this.getUploadData}
                      beforeUpload={(file) => this.validateFile(file)}
                      maxCount={1}
                    >
                      <Button icon={<UploadOutlined />}>
                       
                        {this.context.translate("_CLICKTOUPLOAD_EXCELFILE_")}
                      </Button>
                    </Upload>
                  </Form.Item>

                  <div className="formBtnGroup">
                    <div
                      style={{ display: this.props.params.id ? "" : "none" }}
                    >
                      <Button
                        className="formCancelButton"
                        // style={{ backgroundColor: config.activeColor }}
                        onClick={() => this.passengerStore?.sampleExcelFormat()}
                      >
                        
                        {this.context.translate("_SAMPLE_")}
                       
                      </Button>
                    </div>
                    <Button
                      type="primary"
                      className="formSaveButton"
                      htmlType="submit"
                      // loading={this.state.loading}
                    >
                      {this.context.translate("_UPLOAD_")}
                    </Button>
                  </div>
                </Form>
              </Modal>
            </>
          )} */}
          <Modal
            open={this.state.passengerId.length !== 0 && this.state.openModal}
            // open={this.state.openModal}
            // title="Reassign Vehicle"
            title={this.context.translate("_REASSIGN_VEHICLE_")}
            onOk={() => this.setState({ openModal: false })}
            onCancel={() => this.setState({ openModal: false })}
            footer={false}
          >
            {/* {console.log(this.state.selectedVehicle.length !==0 ,this.state.renewVehicle,"sfgdfg")} */}
            <Form
              name="renewVehicle"
              layout="vertical"
              ref={this.formRef}
              onFinish={this.onReassignVehicle}
              style={{ maxWidth: "100%" }}
            >
              <Form.Item
                // label="Select Vehicle"
                label={this.context.translate("_SELECT_VEHICLE_")}
                name="vehicleId"
                rules={[
                  {
                    required: true,
                    message: this.context.translate("_SELECT_VEHICLE_"),
                  },
                ]}
              >
                <Select
                  // placeholder="Select Asset"
                  placeholder={this.context.translate(
                    "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                  )}
                  showSearch
                  // fieldNames={{ value: "vehicleId", label: "vehicleNo" }}
                  optionFilterProp="children"
                  // options={this.vehicleStore?.getVehiclesUsingCompanyId}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
              </Form.Item>

              <Row justify={"end"}>
                <Space style={{ margin: "10px" }}>
                  <Button type="primary" htmlType="submit">
                    {/* Submit */}
                    {this.context.translate("_SUBMIT_")}
                  </Button>
                </Space>
              </Row>
            </Form>
          </Modal>
        </div>

        {this.state.showDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span> {this.context.translate("_REMOVE_PASSENGER_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.showDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_PASSENGER_DELETE_POPUP_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ showDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={(e) => {
                  this.deleteMultiplePassenger(this.state.passengerId);

                  this.setState({ showDeleteModal: false, passengerId: "" });
                }}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.openPassengerForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openPassengerForm}
            placement={
              this.context.locale.language === "english" ? "right" : "left"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ADD_PASSENGER_")}
                <p className="formDescription">
                  {this.context.translate("_PASSENGER_ADD_FORM_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openPassengerForm: false })}
            onCancel={() =>
              this.setState({ openPassengerForm: false, passengerIdEdit: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <PassengerAdd
                passengerIdEdit={this.state.passengerIdEdit}
                response={this.responseMsg}
                schollPassenger={this.state.schollPassenger}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.showAlertModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span> {this.context.translate("_FLEET_ALERT_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showAlertModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Please select vehicles."
            centered
            open={this.state.showAlertModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_PLEASE_SELECT_PASSENGER_")}</p>
            </div>
            <div>
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ showAlertModal: false })}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.showUpload && (
          <>
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.showUpload}
              placement={
                this.context.locale.language === "english" ? "right" : "left"
              }
              footer={false}
              title={
                <div className="uploadExcelTitle">
                  <Image
                    style={{ height: "60px" }}
                    src={UploadTitleIcon}
                  ></Image>
                  <span> {this.context.translate("_UPLOAD_EXCEL_TITLE_")}</span>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ showUpload: false })}
              onCancel={() =>
                this.setState({
                  showUpload: false,
                  excelFile: "",
                  companyId: "",
                })
              }
            >
              <Form
                name="excelimport"
                layout="vertical"
                onFinish={this.onExcelSubmit}
                style={{ margin: "16px 0px" }}
              >
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                  <Form.Item
                    name="companyId"
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate("_ACCOUNT_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[{ required: true, message }]}
                    required={false}
                  >
                    <CompanyAutocomplete
                      onChange={(companyId) => {
                        this.setState({ companyId: companyId.value });
                        this.companySearch(companyId);
                        this.vehicleStore.getVehiclesCompanyId(companyId.value);
                      }}
                    />
                  </Form.Item>
                )}

                <Form.Item
                  className="uploadCompany"
                  label={
                    <span>
                      {this.context.translate("_SELECT_VEHICLE_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  // label={this.context.translate("_SELECT_VEHICLE_")}
                  name="vehicleId"
                  rules={[
                    {
                      required: true,
                      message: this.context.translate("_SELECT_VEHICLE_"),
                    },
                  ]}
                  required={false}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(inputValue, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                      (val) => {
                        return (
                          <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                        );
                      }
                    )}
                  </Select>
                </Form.Item>
                <Dragger
                  showProgress="true"
                  name="excelFile"
                  // action={config.baseURL + "/index.php?c=company&a=fileupload"}
                  listType="text"
                  // data={{
                  //   fileType: "passengerimport",
                  //   fieldName: "excelFile",
                  // }}
                  onChange={this.getUploadData}
                  beforeUpload={(file) => this.validateFile(file)}
                  customRequest={(options) => this.uploadFunction(options)}
                  maxCount={1}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "20px",
                    }}
                  >
                    <div>
                      <Image
                        style={{ width: "90px" }}
                        src={uploadOutlined}
                      ></Image>
                    </div>
                    <div className="uploadFileText">
                      <span>
                        {this.context.translate("_UPLOAD_EXCEL_FILE_")}
                      </span>
                      <p>
                        {this.context.translate("_UPLOAD_TEXT_")}{" "}
                        <span
                          style={{
                            color: "var(--Blue-6, #1890FF)",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                        >
                          {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                        </span>
                        {this.context.translate("_UPLOAD_TEXT_2_")}
                      </p>
                    </div>
                  </div>
                </Dragger>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    textAlign: "center",
                    marginTop: "16px",
                  }}
                >
                  <div className="sampleDownload">
                    <span> {this.context.translate("_SAMPLE_DOWNLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_EXCEL_DESC_")}</p>
                    <Button
                      onClick={() => this.passengerStore.sampleExcelFormat()}
                    >
                      <Image src={sampleDownloadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {" "}
                        {this.context.translate("_SAMPLE_DOWNLOAD_")}
                      </span>
                    </Button>
                  </div>

                  <div className="sampleUpload">
                    <span> {this.context.translate("_SAMPLE_UPLOAD_")}</span>
                    <p>{this.context.translate("_SAMPLE_DOWNLOAD_DESC_")}</p>
                    <Button>
                      <Image src={sampleUploadIcon}></Image>
                      <span style={{ color: "#2563EB", fontSize: "14px" }}>
                        {this.context.translate("_SAMPLE_UPLOAD_")}
                      </span>{" "}
                    </Button>
                  </div>
                </div>

                <Space className="uploadFooter">
                  <Button
                    className="uploadCancelButton"
                    onClick={() =>
                      this.setState({
                        showUpload: false,
                        excelFile: "",
                        companyId: "",
                      })
                    }
                  >
                    {this.context.translate(
                      "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                    )}
                  </Button>
                  <Button
                    htmlType="submit"
                    className="uploadButton"
                    // onClick={() => this.onExcelSubmit()}
                  >
                    {this.context.translate("_UPLOAD_")}
                  </Button>
                </Space>
              </Form>
            </Drawer>{" "}
          </>
        )}
      </>
    );
  }
}
PassengerList.contextType = StoreContext;
export default observer(withRouter(PassengerList));
